import useMutationPermissionCreateUpdate from './permission-use-mutation-create-update';
import useMutationPermissionDelete from "./permission-use-mutation-delete";

export const permissionUseMutation = {
    createUpdate: useMutationPermissionCreateUpdate,
    delete: useMutationPermissionDelete,
};